import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import Add from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import Spinner from 'react-bootstrap/Spinner';
import ArticlesList from './ArticlesList';
import ArticlesInventoryAPI from '../api/ArticlesInventoryAPI';
import ArticlesModal from './ArticlesModal';
import ArticlesInventoryType from '../api/ArticlesInventoryTypeAPI';
import ArticlesListActions from './ArticlesListActions';

const Articles = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [articles, setArticles] = useState([]);
    const [inventoryTypes, setInventoryTypes] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    useEffect(() => {
        listInventoryType();
        listArticlesInventory();
    }, []);

    const listArticlesInventory = async () => {
        let articleInv = await ArticlesInventoryAPI.listarArticulosInventario();
        setArticles(articleInv);
    }

    const listInventoryType = async () => {
        let inventoryTypes = await ArticlesInventoryType.listarTipoInventario();
        setInventoryTypes(inventoryTypes);
    }

    const ListArticlesInventory = () => {
        return (
            <ArticlesList
                reactTableData={articles}
                Callback={listArticlesInventory}
                inventoryTypes={inventoryTypes}
                ReactTableActions={ArticlesListActions}
                articlesInvoiceProcess={props.articlesInvoiceProcess}
                preAddItemArticle={props.preAddItemArticle}
            />);
    }

    return (
        <Fragment>
            <Row>
                <Col md={12}><Tooltip title="Agregar Articulo">
                    {
                        props.articlesInvoiceProcess == true ? <></> : <>
                            <Button style={{ float: 'right' }} className="btn btn-sm" color="primary" onClick={() => {
                                setOpenModal(true);
                            }}>
                                <Add style={{ color: 'white' }} />
                            </Button></>
                    }
                </Tooltip>
                    {isLoading ? <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div> :
                        <ListArticlesInventory />}
                </Col>
            </Row>

            <ArticlesModal
                article={null}
                closeModal={() => setOpenModal(false)}
                opened={openModal}
                inventoryTypes={inventoryTypes}
                Callback={listArticlesInventory}
            />
        </Fragment>
    );


}
export default Articles;
